import { render } from "./TaskPostReview.vue?vue&type=template&id=26dacd81&scoped=true"
import script from "./TaskPostReview.vue?vue&type=script&lang=js"
export * from "./TaskPostReview.vue?vue&type=script&lang=js"

import "./TaskPostReview.vue?vue&type=style&index=0&id=26dacd81&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26dacd81"]])

export default __exports__